import { createSlice } from "@reduxjs/toolkit";
import {
  getUserGroups,
  getUserInvites,
  getGroupActivity,
  getNotifications,
  getUnreadCount,
  markAllNotificationsRead,
} from "./thunks";
import { logout, expiredLogout } from "../auth/thunks";
import { setField, setFieldFromPayloadKey } from "../utils/asyncHandlers";

const initialState = {
  groups: {},
  userInvites: {},
  groupActivity: [],
  notifications: [],
  unreadCount: 0,
};

const socialSlice = createSlice({
  name: "social",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getUserGroups.fulfilled, setField("groups"))
      .addCase(getUserInvites.fulfilled, setField("userInvites"))
      .addCase(
        getGroupActivity.fulfilled,
        setFieldFromPayloadKey("groupActivity", "activity", [])
      )
      .addCase(
        getNotifications.fulfilled,
        setFieldFromPayloadKey("notifications", "notifications", [])
      )
      .addCase(
        getUnreadCount.fulfilled,
        setFieldFromPayloadKey("unreadCount", "unread_count", 0)
      )
      .addCase(markAllNotificationsRead.fulfilled, (state) => {
        state.notifications = state.notifications.map((n) => ({ ...n, is_read: true }));
        state.unreadCount = 0;
      })
      .addCase(logout.fulfilled, () => initialState)
      .addCase(expiredLogout.fulfilled, () => initialState);
  },
});

export default socialSlice.reducer;
